import has from 'lodash/has';
import get from 'lodash/get';
import set from 'lodash/set';
import size from 'lodash/size';
import cloneDeep from 'lodash/cloneDeep';
import {modify} from "mythil/object";
import {SETTINGS_ACTIONS} from "~/actions/settingsActions";

export default function reduceSettings(settings, action) {
    switch(action.type) {
        case SETTINGS_ACTIONS.CHANGE_GROUP_OPEN:
            return (() => {
                let { identifier, groupName, open } = action;

                let path = `${identifier}.groupStates.${groupName}`;

                if(!has(settings, path)) { set(settings, path, null); }
                return modify(settings, path, open);
            })();

        case SETTINGS_ACTIONS.CHANGE_FILTER_OPEN:
            return (() => {
                let { identifier, groupName, filterName, open } = action;

                let groupPath = `${identifier}.groupStates.${groupName}`;
                let filterPath = `${groupPath}.${filterName}`;

                if(!has(settings, filterPath)) { set(settings, filterPath, null); }
                settings = modify(settings, filterPath, open)

                return settings;
            })();

        case SETTINGS_ACTIONS.CHANGE_FILTER_ORDER:
            return (() => {
                let { identifier, filterOrder } = action;

                let path = `${identifier}.filterOrder`;

                if(!has(settings, path)) { set(settings, path, null); }
                settings = modify(settings, path, filterOrder)

                return settings;
            })();

        case SETTINGS_ACTIONS.RESET_FILTERS:
            return (() => {
                let { identifier } = action;
                const resetProperties = ["groupStates", "filterOrder"];

                resetProperties.forEach((prop) => {
                    const propPath = `${identifier}.${prop}`;
                    settings = modify(settings, propPath, undefined)
                })

                if (size(get(settings, identifier)) <= 0) {
                    settings = modify(settings, identifier, undefined)
                }

                return settings;
            })();

        case SETTINGS_ACTIONS.CHANGE_TOOLTIPS_ACTIVE:
            return modify(settings, 'tooltipsHidden', !action.active);

    }

    return settings;
}